import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Overlayable} from "../../../interfaces/overlayable";
import {GameSessionService} from "../../../services/game-session.service";
import {TimerButtonService} from "../../../services/timer-button.service";
import {MqttClientService} from "../../../services/mqtt-client.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {GameServerMessage} from "../../../interfaces/game-server-message";
import {TimerButtonState} from "../../../enums/timer-button-state";


@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-game-session-controller-overlay-main',
  templateUrl: './game-session-controller-overlay-main.component.html',
  styleUrls: ['./game-session-controller-overlay-main.component.scss']
})
export class GameSessionControllerOverlayMainComponent implements Overlayable, OnInit {

  @Output() onClosed = new EventEmitter<boolean>();

  timeLeft = 250;

  gameSessionActive = false;
  gameSessionPaused = false;

  currentMinutes = 30;
  currentSeconds = 3;

  private readonly PAUSE_LABEL = "Pausiert";
  label = this.PAUSE_LABEL;

  constructor(
    private gameSessionService: GameSessionService,
    private timerButtonService: TimerButtonService,
    private mqttClient: MqttClientService
  ) {

    this.gameSessionService.gameSessionActive$.subscribe(response => {
      this.gameSessionActive = response;
    });

    this.gameSessionService.gameSessionPaused$.subscribe(response => {
      this.gameSessionPaused = response;

      if(this.gameSessionPaused) {
        this.label = this.PAUSE_LABEL;
      }

    });

  }

  ngOnInit() {
    this.timerButtonService.subscribe(); // should be somewhere else in project
    this.timerButtonService.onUpdate().pipe(untilDestroyed(this)).subscribe((newValue) => {
      this.handleUpdate(newValue);
    });
  }

  handleUpdate(msg: GameServerMessage): void {
    if(msg.state === TimerButtonState.PLAY) {
      this.setLabelByTimerValue(msg.timerValue);
    }
  }

  extendGameSession() {
    this.gameSessionService.extendGameSession();
  }

  setLabelByTimerValue(time: number): void {
    const date = new Date(time * 1000);
    const hours = date.getHours() - 1;
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    this.label = `${(hours * 60 + minutes).toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    // this.label = new Date(time * 1000).toISOString().substring(14, 19);
    this.currentMinutes = hours * 60 + minutes;
    this.currentSeconds = seconds;
  }

}
